export default "__VITE_ASSET__CW1UrjBm__"